import { CmsPageContentType } from 'app/modules/cms/tools/types';

export const associativeCmsMap = new Map<string, string>([
  ['confirmOfferStep', CmsPageContentType.CUSTOMER_OFFERS_STEP_CONTENT],
  ['recommendedOfferStep', CmsPageContentType.CUSTOMER_OFFERS_STEP_CONTENT],
  ['productStep', CmsPageContentType.CUSTOMER_SUBSCRIBER_STEP_CONTENT],
  ['enterpriseIdentityStep', CmsPageContentType.CUSTOMER_SUBSCRIBER_STEP_CONTENT],
  ['identityStep', CmsPageContentType.CUSTOMER_SUBSCRIBER_STEP_CONTENT],
  ['howToJoinStep', CmsPageContentType.CUSTOMER_SUBSCRIBER_STEP_CONTENT],
  ['bankAccountInfoStep', CmsPageContentType.CUSTOMER_SUBSCRIBER_STEP_CONTENT],
  ['summaryStep', CmsPageContentType.CUSTOMER_SUMMARY_STEP_CONTENT],
  ['signatureStep', CmsPageContentType.CUSTOMER_ESIGN_STEP_CONTENT],
  ['confirmationStep', CmsPageContentType.CUSTOMER_CONFIRMATION_STEP_CONTENT],
  ['confirmationBarcodeStep', CmsPageContentType.CUSTOMER_CONFIRMATION_BARCODE_STEP],
  ['cancellationStep', CmsPageContentType.CUSTOMER_CANCELLATION_STEP_CONTENT],
  ['tooLateStep', CmsPageContentType.CUSTOMER_OFFERS_STEP_CONTENT],
  ['tooEarlyStep', CmsPageContentType.CUSTOMER_OFFERS_STEP_CONTENT],
  ['customerInformationStep', CmsPageContentType.CUSTOMER_SUBSCRIBER_STEP_CONTENT],
  ['insuredElementStep', CmsPageContentType.INSURED_ELEMENT_STEP_CONTENT],
  ['paymentStep', CmsPageContentType.CUSTOMER_PAYMENT_STEP_CONTENT],
  ['paymentConfirmationStep', CmsPageContentType.CUSTOMER_PAYMENT_CONFIRMATION_STEP_CONTENT],
  ['paymentFailureStep', CmsPageContentType.CUSTOMER_PAYMENT_FAILURE_STEP_CONTENT]
]);
